import BorderSides from "%/dynamic-component-editor/options/border-sides";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet segmented control: the selected segment's border (border-sides shape).
export default class SelectedBorder extends BorderSides {
  static userInterfaceComponent = {
    label: "Selected Border",
    component: inspectorTools.NEW_BORDER_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    props: {
      heading: "Selected Border",
    },
  };
}
